import {AUTHORIZED_MAX_PLAYERS, AUTHORIZED_ROOM_MODES} from '../constants'

export type RoomInfo = {
  name: string
  maxPlayers: typeof AUTHORIZED_MAX_PLAYERS[number]
  mode: typeof AUTHORIZED_ROOM_MODES[number]
}